import { Box, List, ListItem, ListItemText, Typography } from '@mui/material';
import { addGeofenceCheckedId, setFilterTab } from 'app/actions/map';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

const MapTaskInfoList = function () {
  const dispatch = useDispatch();
  const { ref: mapRef, geofenceCheckedId, taskSelectedItem, filterTab } = useSelector((state) => state.map);

  const handleItemColumnClick = (value) => {
    if (geofenceCheckedId.indexOf(value.geofence_id) === -1) {
      dispatch(addGeofenceCheckedId(value.geofence_id));
    }

    if (filterTab !== 'geofence') {
      dispatch(setFilterTab('geofence'));
    }

    mapRef.current.handleClosePopup();
    mapRef.current.handleFlyTo([value.latitude, value.longitude]);
  };

  return (
    <Box
      component='div'
      sx={{
        width: '100%',
        height: '100%',
      }}>
      <List
        disablePadding
        sx={(theme) => ({
          padding: theme.spacing(0),
          border: '1px solid',
          borderColor: theme.palette.divider,
          borderRadius: theme.shape.borderRadius,
          overflow: 'hidden',
        })}>
        <ListItem
          disablePadding
          sx={(theme) => ({
            position: 'absolute',
            top: '0',
            left: '0',
            width: '100%',
            height: '100%',
            zIndex: '2',
            pointerEvents: 'none',
            padding: theme.spacing(0),
            '.MuiListItemText-root': {
              display: 'flex',
              justifyContent: 'space-between',
              height: '100%',
              position: 'relative',
              flex: 'none',
              '&:before': {
                content: '""',
                position: 'absolute',
                top: '0',
                right: '0',
                height: '100%',
                bgcolor: theme.palette.divider,
                width: '1px',
                zIndex: '1',
                pointerEvents: 'none',
              },
              '&:last-of-type': {
                flex: '1',
                '&:before': {
                  display: 'none',
                },
              },
            },
          })}>
          {config.mapTransportTaskColumns
            .filter((column) => column.name !== 'dut')
            .map((column) => (
              <ListItemText key={column.name} style={{ width: column.width }} />
            ))}
        </ListItem>
        <ListItem
          disablePadding
          sx={(theme) => ({
            width: '100%',
            userSelect: 'none',
            borderRadius: '0',
            '.MuiListItemText-root': {
              display: 'flex',
              flex: 'none',
              margin: theme.spacing(0),
              padding: theme.spacing(1),
              alignItems: 'center',
              bgcolor: 'background.default',
              borderBottom: '1px solid',
              borderColor: theme.palette.divider,
              '&:first-of-type': {
                paddingLeft: theme.spacing(2),
              },
              '&:last-of-type': {
                flex: '1',
                paddingRight: theme.spacing(2),
              },
              '.MuiTypography-root': {
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis',
              },
            },
          })}>
          {config.mapTransportTaskColumns
            .filter((column) => column.name !== 'dut')
            .map((column) => (
              <ListItemText key={column.name} disableTypography style={{ width: column.width }}>
                <Typography>{column.label}</Typography>
              </ListItemText>
            ))}
        </ListItem>
        {taskSelectedItem.ttn_task.map((task, key) => (
          <ListItem
            key={key}
            disablePadding
            sx={(theme) => ({
              width: '100%',
              userSelect: 'none',
              borderRadius: '0',
              '.MuiListItemText-root': {
                display: 'flex',
                flex: 'none',
                margin: theme.spacing(0),
                padding: theme.spacing(0.5, 1),
                alignItems: 'center',
                '&:first-of-type': {
                  paddingLeft: theme.spacing(2),
                },
                '&:last-of-type': {
                  flex: '1',
                  paddingRight: theme.spacing(2),
                },
                '.MuiTypography-root': {
                  overflow: 'hidden',
                  whiteSpace: 'nowrap',
                  textOverflow: 'ellipsis',
                },
              },
            })}>
            {config.mapTransportTaskColumns
              .filter((column) => column.name !== 'dut')
              .map((column) => {
                switch (column.name) {
                  case 'section':
                    return (
                      <ListItemText key={column.name} disableTypography style={{ width: column.width }}>
                        <Typography>{task.section}</Typography>
                      </ListItemText>
                    );
                  case 'gs_num':
                    return (
                      <ListItemText
                        key={column.name}
                        disableTypography
                        sx={{
                          width: column.width,
                          cursor: task.geofence_id ? 'pointer' : 'default',
                        }}
                        onClick={() => handleItemColumnClick(task)}>
                        <Typography>{task.gs_num}</Typography>
                      </ListItemText>
                    );
                  case 'product':
                    return (
                      <ListItemText key={column.name} disableTypography style={{ width: column.width }}>
                        <Typography>{task.product}</Typography>
                      </ListItemText>
                    );
                  case 'volume':
                    return (
                      <ListItemText key={column.name} disableTypography style={{ width: column.width }}>
                        <Typography>{task.volume}</Typography>
                      </ListItemText>
                    );
                }
              })}
          </ListItem>
        ))}
      </List>
    </Box>
  );
};

export default MapTaskInfoList;
